const extractText = (content: string | null | undefined) => {
  if (typeof content !== 'string') {
    return '';
  }

  const cleanContent = content
    ?.replaceAll(/(<([^>]+)>)/gi, '')
    .replaceAll('&hellip;', '...')
    .replaceAll('&nbsp;', ' ')
    .replaceAll('&#039;', "'")
    .replaceAll('&#8217;', "'")
    .replaceAll('&#8220;', '"')
    .replaceAll('&#8221;', '"')
    .replaceAll('&#8211;', '-')
    .replaceAll('&#038;', '&')
    .replaceAll('&#8212;', '—');
  return cleanContent;
};

export default extractText;
